<div class="container-fluid">
  @if (isLoading) {
  <div class="loading">
    <mat-progress-spinner mode="indeterminate" diameter="75" class="spinner"></mat-progress-spinner>
  </div>
  }
  <div class="col-md-8">
    @if (plotParams.length>0) {
    <mat-tab-group class="inner_tab" [selectedIndex]="selectedParam"
      (selectedIndexChange)="onSelectedParamChange($event)">
      @for (param of plotParams; track param) {
      <mat-tab [label]="param.name"></mat-tab>
      }
    </mat-tab-group>
    }
  </div>
  <div class="row">
    <div #chartContainer [ngClass]="{'chart_wide': wideGraph, 'col-md-11': wideGraph,
      'chart': !wideGraph, 'col-md-6': !wideGraph}">
      <template #chart></template>
      @if (plotParams.length==0 && !isLoading) {
      <h3 class="error_message">{{errorMessage}}</h3>
      }
      <i class="zmdi-download zmdi" style="font-size: large;
        position: absolute;
        bottom: 10px;
        right: 50px;
        cursor: pointer;
        " (click)="downloadChart()">
      </i>
    </div>
    @if (plotParams.length > 0) {
    <div [ngClass]="{'info_card_wide': wideGraph, 'col-md-6': wideGraph,
      'info_card': !wideGraph, 'col-md-4': !wideGraph}">
      <mat-card>
        <mat-card-content>
          <mat-grid-list [cols]="wideGraph?6:2" rowHeight="12:1" class="parameters">
            @for (param of displayingData; track param) {
            <mat-grid-tile><span style="font-weight: bold;"> {{param.name}}: </span></mat-grid-tile>
            <mat-grid-tile><span> {{param.data | number: '1.0-3'}}</span></mat-grid-tile>
            }
          </mat-grid-list>
          @if (displayingData) {
          <mat-divider></mat-divider>
          }
          <div class="sliders form-horizontal iter_setting">
            <div class="form-group iteration-slider">
              <app-slider class="col-sm-12" label="Iteration" [antd]="true" [min]="0" [max]="largestIter"
                [(value)]="selectedIteration" [step]="1" (valueChange)="loadChart(selectedParam)"></app-slider>
            </div>
          </div>
          <div style="display: flex; gap: 10px">
            <nz-input-group class="nz-input-group-floating-label" [style.flexGrow]="1">
              <label>Lower Bound</label>
              <input type="number" noScrollNumber nz-input placeholder="Lower Bound" [(ngModel)]="lowLimitY"
                (keyup)="updateGraphScale($event)" />
            </nz-input-group>
            <nz-input-group class="nz-input-group-floating-label" [style.flexGrow]="1">
              <label>Upper Bound</label>
              <input type="number" noScrollNumber nz-input placeholder="Upper Bound" [(ngModel)]="upLimitY"
                (keyup)="updateGraphScale($event)" />
            </nz-input-group>
          </div>


          @if (plotParams[selectedParam]?.name === 'step history') {
          <mat-divider></mat-divider>
          <div style="display: flex; gap: 10px; margin-top: 10px">
            <nz-input-group class="nz-input-group-floating-label" [style.flexGrow]="1">
              <label>X Lower Bound</label>
              <input type="number" noScrollNumber nz-input placeholder="X Lower Bound" [(ngModel)]="lowLimitX"
                (keyup)="updateGraphScale($event)" />
            </nz-input-group>
            <nz-input-group class="nz-input-group-floating-label" [style.flexGrow]="1">
              <label>X Upper Bound</label>
              <input type="number" noScrollNumber nz-input placeholder="X Upper Bound" [(ngModel)]="upLimitX"
                (keyup)="updateGraphScale($event)" />
            </nz-input-group>
          </div>
          }
          <i style="
              position: absolute;
              top: 5px;
              right: 10px;
              width: fit-content;
              margin: 0px;
            "
            [ngClass]="{'zmdi':true, 'zmdi-fullscreen':!wideGraph, 'zmdi-fullscreen-exit':wideGraph, 'zmdi-hc-2x':true, 'full_screen':true}"
            (click)="wideGraph=!wideGraph; loadChart()"></i>
        </mat-card-content>
      </mat-card>
    </div>
    }
  </div>
</div>